<template>
    <div class="nf-form-wrap ">
        <div class="wrap nf-box-bg-style">
            <el-row
                class="top-title "
                type="flex"
                align="middle"
            >
                <el-col>{{ $route.meta.title }}</el-col>
                <slot name="header-top-right" />
                <el-col v-if="isRrightTopTil">
                    <el-row 
                        type="flex"
                        align="middle"
                    
                        justify="end"
                    >
                        <span class="red">* </span>
                        <span class="r-text">&nbsp;为必填</span>
                    </el-row>
                </el-col>
            </el-row>
            <div class="content">
                <slot name="content" />
            </div>
        </div>
        <!-- 如果没有重置按钮 和提交按钮 默认footer不显示 -->
        <footer v-if="onSaveBtnClick || onResetBtnClick">
            <el-row
                
                tag="div"
                class="foot-btn nf-box-bg-style "
                :class="{active:isCollapse}"
                align="middle"
                type="flex"
            >
                <el-button
                    v-if="onSaveBtnClick"
                    type="primary"
                    :loading="isLoading"
                    size="medium"
                    @click="handleSaveClick"
                >
                    {{ saveBtnText }}
                </el-button>
                <el-button
                    v-if="onResetBtnClick"
                    size="medium"
                    @click="onResetBtnClick"
                >
                    {{ resetBtnText }}
                </el-button>
                <slot name="foot-btn" />
            </el-row>
        </footer>
    </div>
</template>
<script>
export default {
    name:'NfFormWrap',
    props:{
        // 按钮点击事件回调
        onSaveBtnClick:{
            type:[Function,Boolean],
            default:false
        },
        // 重置按钮 如果有此方法则显示按钮
        onResetBtnClick:{
            type:[Function , Boolean],
            default:false
        },
        // 提交按钮文字
        saveBtnText:{
            type:String,
            default:"提 交"
        },
        // 重置文字按钮
        resetBtnText:{
            type:String,
            default:"重 置"
        },
        // 右上角提示 *必填 是否显示
        isRrightTopTil:{
            type:Boolean,
            default:true
        }
    },
    data (){
        return {
            isLoading:false,
        }
    },
    computed:{
        isCollapse (){
            return this.$store.state.Layout.isCollapse;
        }
    },
    methods:{
        handleSaveClick(){
            if(this.onSaveBtnClick){
                this.onSaveBtnClick((isTrue)=>{
                    this.isLoading= isTrue;
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped >
    .wrap{
        .top-title{
            padding: 13px 20px;
            background:#fff;
            font-size: 13px;
            line-height: 13px;
            border-bottom: 1px solid #eee;
            span{
                color: #FF3B30;
            }
            .r-text{
                color: #999;
            }
           
        }
        .content{
            padding: 20px;
        }
    }
    footer{
        height: 70px;
        width: 100%;
        .foot-btn{
            padding:0 20px;
            background: #fff;
            position: fixed;
            left: 200px;
            border-radius: 0;
            height: 60px;
            bottom: 0;
            right: 0;
            transition: all .5s;
            button{
                width: 160px;
            }
            &.active{
                left: 65px;
            }
        }
    }
    
</style>